import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goToEmail } from "./action";
export const template = {
    layout: {
        id: ROUTE.NO_MUTUAL_FUND_INSTRUCTION,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "containerStack", type: WIDGET.STACK },
            { id: "bottomCTAStack", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM },
            { id: "spaceLG", type: WIDGET.SPACE }
        ],
    },
    datastore: {
        questionText: {
            label: 'We’re currently available to mutual fund investors only',
            fontWeight: '600',
            fontSize: FontSizeTokens.XL,
            lineHeight: 28,
            color: ColorTokens.Grey_Night,
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Poppins
        },
        yesText: {
            label: 'We’re constantly working on expanding our offering to more customers. Please try again later.',
            fontSize: FontSizeTokens.SM,
            fontWeight: '400',
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Inter
        },
        noText: {
            label: 'No',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        containerStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "noMutualFundsBanner", type: WIDGET.IMAGE },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "questionText", type: WIDGET.TEXT },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "yesText", type: WIDGET.TEXT },
            ]
        },
        noMutualFundsBanner: {
            uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/no_mutualfundsBanner.png',
            size: ImageSizeTokens.XXXL,
        },
        spaceLG: {
            size: SizeTypeTokens.LG
        },
        spaceSM: {
            size: SizeTypeTokens.SM
        },
        spaceXL: {
            size: SizeTypeTokens.XL
        },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL
        },
        bottomCTAStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            alignItems: StackAlignItems.center,
            action: {
                type: ACTION.GO_TO_EMAIL,
                routeId: ROUTE.NO_MUTUAL_FUND_INSTRUCTION
            },
            widgetItems: [
                { id: "haveMutualFundQuestionText", type: WIDGET.TEXT },
                { id: "clickHereProceedText", type: WIDGET.TEXT },
            ]
        },
        haveMutualFundQuestionText: {
            label: 'Have mutual fund investments?',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Night
        },
        clickHereProceedText: {
            label: 'Click here to proceed',
            fontSize: FontSizeTokens.MD,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Primary_100,
            fontFamily: FontFamilyTokens.Inter
        }
    },
};
export const noMutualFundMF = {
    onLoad: async () => {
        return Promise.resolve(template);
    },
    actions: {
        [ACTION.GO_TO_EMAIL]: goToEmail,
    },
};
